/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectOrdersToProjectRequest
 */
export interface ConnectOrdersToProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectOrdersToProjectRequest
     */
    projectId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConnectOrdersToProjectRequest
     */
    orderIds?: Array<string> | null;
}

export function ConnectOrdersToProjectRequestFromJSON(json: any): ConnectOrdersToProjectRequest {
    return ConnectOrdersToProjectRequestFromJSONTyped(json, false);
}

export function ConnectOrdersToProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectOrdersToProjectRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'orderIds': !exists(json, 'orderIds') ? undefined : json['orderIds'],
    };
}

export function ConnectOrdersToProjectRequestToJSON(value?: ConnectOrdersToProjectRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'projectId': value.projectId,
        'orderIds': value.orderIds,
    };
}


